(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Components/Admin-Entries/admin-entries.module": [
		"./src/app/Components/Admin-Entries/admin-entries.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~2df035f0",
		"default~Components-Admin-Entries-admin-entries-module~Components-QR-Agency-qr-agency-module~Componen~adc61e8d",
		"default~Components-Admin-Entries-admin-entries-module~admin-entries-data-admin-entries-data-module",
		"Components-Admin-Entries-admin-entries-module"
	],
	"./Components/Agency-Entries/agency-entries.module": [
		"./src/app/Components/Agency-Entries/agency-entries.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~2df035f0",
		"default~Components-Agency-Entries-agency-entries-module~agency-entries-data-agency-entries-data-module",
		"Components-Agency-Entries-agency-entries-module"
	],
	"./Components/QR-Agency/qr-agency.module": [
		"./src/app/Components/QR-Agency/qr-agency.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~2df035f0",
		"default~Components-Admin-Entries-admin-entries-module~Components-QR-Agency-qr-agency-module~Componen~adc61e8d",
		"default~Components-QR-Agency-qr-agency-module~qr-agency-data-qr-agency-data-module",
		"Components-QR-Agency-qr-agency-module"
	],
	"./Components/TL-Entries/tl-entries.module": [
		"./src/app/Components/TL-Entries/tl-entries.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~2df035f0",
		"default~Components-Admin-Entries-admin-entries-module~Components-QR-Agency-qr-agency-module~Componen~adc61e8d",
		"default~Components-TL-Entries-tl-entries-module~tl-entries-data-tl-entries-data-module",
		"Components-TL-Entries-tl-entries-module"
	],
	"./Components/login/login.module": [
		"./src/app/Components/login/login.module.ts",
		"Components-login-login-module"
	],
	"./admin-entries-data/admin-entries-data.module": [
		"./src/app/Components/Admin-Entries/admin-entries-data/admin-entries-data.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~2df035f0",
		"default~Components-Admin-Entries-admin-entries-module~Components-QR-Agency-qr-agency-module~Componen~adc61e8d",
		"default~Components-Admin-Entries-admin-entries-module~admin-entries-data-admin-entries-data-module"
	],
	"./agency-entries-data/agency-entries-data.module": [
		"./src/app/Components/Agency-Entries/agency-entries-data/agency-entries-data.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~2df035f0",
		"default~Components-Agency-Entries-agency-entries-module~agency-entries-data-agency-entries-data-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/Components/Entries/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./entries-data/entries-data.module": [
		"./src/app/Components/Entries/entries-data/entries-data.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"entries-data-entries-data-module"
	],
	"./qr-agency-data/qr-agency-data.module": [
		"./src/app/Components/QR-Agency/qr-agency-data/qr-agency-data.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~2df035f0",
		"default~Components-Admin-Entries-admin-entries-module~Components-QR-Agency-qr-agency-module~Componen~adc61e8d",
		"default~Components-QR-Agency-qr-agency-module~qr-agency-data-qr-agency-data-module"
	],
	"./tl-entries-data/tl-entries-data.module": [
		"./src/app/Components/TL-Entries/tl-entries-data/tl-entries-data.module.ts",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~8d841ce1",
		"default~Components-Admin-Entries-admin-entries-module~Components-Agency-Entries-agency-entries-modul~2df035f0",
		"default~Components-Admin-Entries-admin-entries-module~Components-QR-Agency-qr-agency-module~Componen~adc61e8d",
		"default~Components-TL-Entries-tl-entries-module~tl-entries-data-tl-entries-data-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/layout/layout.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/Components/layout/layout.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-default\" *ngIf=\"currentRouter ==''\">\n    <div class=\"container-fluid header-styling\">\n        <ul class=\"nav navbar-nav navbar-logo mx-auto\">\n            <img src=\"../../../assets/images/abnbev.png\" class=\"d-inline-block blue-icon\" alt=\"\">\n        </ul>\n    </div>\n</nav>\n<!-- navbar code -->\n<nav class=\"navbar navbar-default \" *ngIf=\"currentRouter !=''\">\n    <div class=\"container-fluid header-styling\">\n        <div class=\"navbar-header p-10\">\n            <button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\"#myNavbar\">\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n            <a class=\"navbar-brand\" href=\"#myPage\">\n                <img src=\"../../../assets/images/abnbev.png\" class=\"brand-logo\" alt=\"\">\n            </a>\n        </div>\n        <div class=\"collapse navbar-collapse\" id=\"myNavbar\">\n            <ul class=\"nav navbar-nav navbar-right \" style=\"padding-right:20px;\">\n                <li class=\"dropdown\">\n                    <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\"><i class=\"fa fa-bell-o bell-edit\"\n                            style=\"color:black;font-weight:bold;\" aria-hidden=\"true\"></i>\n                        <span style=\"position:relative;top:-24px;left:-24px;width:50px;height:50px;\n                            background-color:#B71717;padding:7px;color:#fff;border-radius:7px;\n                            font-size:12px;\">\n                            {{notification.length}}\n                        </span>\n                        <ul class=\"dropdown-menu dropdown-menu-right\" *ngIf=\"notification?.length > 0\">\n                            <li *ngFor=\"let data of notification\">\n                                <a href=\"#\" class=\"top-text-block\" (click)=\"removeNotification(data)\">\n                                    <div class=\"top-text-heading\"><b>{{data.notification}}</b></div>\n                                    <div class=\"top-text-light\"><i>{{ data.created_date | date:'medium' }}</i></div>\n                                </a>\n                            </li>\n                        </ul>\n                    </a>\n                </li>\n                <li class=\"dropdown\">\n                    <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\"> <img\n                            src=\"../../../assets/images/avatar2.png\" style=\"width:40px; border-radius: 50px;\"\n                            alt=\"profile_pic\"><span\n                            style=\"padding-left:10px;padding-right:10px\">\n                            {{ userName | uppercase}} \n                        </span>\n                        <span class=\"caret\"></span></a>\n                    <ul class=\"dropdown-menu\">\n                        <li><a (click)=\"logout()\">Logout</a></li>\n                    </ul>\n                </li>\n            </ul>\n        </div>\n    </div>\n</nav>\n<!-- navbar code end  -->\n<router-outlet>\n</router-outlet>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n  <router-outlet></router-outlet>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/Components/Entries/entries-routing.module.ts":
/*!**************************************************************!*\
  !*** ./src/app/Components/Entries/entries-routing.module.ts ***!
  \**************************************************************/
/*! exports provided: EntriesRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntriesRoutingModule", function() { return EntriesRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



const routes = [
    {
        path: 'entries',
        children: [
            {
                path: 'dashboard',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'entries-data',
                loadChildren: './entries-data/entries-data.module#EntriesDataModule'
            },
        ]
    }
];
let EntriesRoutingModule = class EntriesRoutingModule {
};
EntriesRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forChild(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], EntriesRoutingModule);



/***/ }),

/***/ "./src/app/Components/Entries/entries.module.ts":
/*!******************************************************!*\
  !*** ./src/app/Components/Entries/entries.module.ts ***!
  \******************************************************/
/*! exports provided: EntriesModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntriesModule", function() { return EntriesModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _entries_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./entries-routing.module */ "./src/app/Components/Entries/entries-routing.module.ts");
/* harmony import */ var src_app_Shared_UserDataProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/Shared/UserDataProvider */ "./src/app/Shared/UserDataProvider.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");






let EntriesModule = class EntriesModule {
};
EntriesModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _entries_routing_module__WEBPACK_IMPORTED_MODULE_3__["EntriesRoutingModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_5__["ReactiveFormsModule"]
        ],
        providers: [src_app_Shared_UserDataProvider__WEBPACK_IMPORTED_MODULE_4__["UserDataProvider"], _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]]
    })
], EntriesModule);



/***/ }),

/***/ "./src/app/Components/layout/layout-routing.module.ts":
/*!************************************************************!*\
  !*** ./src/app/Components/layout/layout-routing.module.ts ***!
  \************************************************************/
/*! exports provided: LayoutRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutRoutingModule", function() { return LayoutRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



const routes = [];
let LayoutRoutingModule = class LayoutRoutingModule {
};
LayoutRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forChild(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], LayoutRoutingModule);



/***/ }),

/***/ "./src/app/Components/layout/layout.component.scss":
/*!*********************************************************!*\
  !*** ./src/app/Components/layout/layout.component.scss ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("li {\n  cursor: pointer !important;\n}\n\n.rating {\n  float: left;\n  padding: 10px !important;\n}\n\n.modal-confirm .modal-content1 {\n  border-radius: 5px;\n  border: none;\n}\n\n.modal-confirm .modal-header {\n  border-bottom: none;\n  position: relative;\n}\n\n.ml-3 {\n  margin-left: 0rem !important;\n}\n\n.check1 {\n  font-size: 64px;\n}\n\n.modal-confirm .icon-box {\n  color: #fff;\n  position: absolute;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  top: -40px;\n  width: 95px;\n  height: 95px;\n  border-radius: 50%;\n  z-index: 9;\n  background: #82ce34;\n  padding: 15px;\n  text-align: center;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n}\n\n/*****/\n\n.top-text-block {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: 400;\n  line-height: 1.42857143;\n  color: #333;\n  white-space: inherit !important;\n  border-bottom: 1px solid #f4f4f4;\n  position: relative;\n}\n\n.top-text-block:hover:before {\n  content: \"\";\n  width: 4px;\n  background: #f05a1a;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  position: absolute;\n}\n\n.top-text-block.unread {\n  background: #ffc;\n}\n\n.top-text-block .top-text-light {\n  color: #999;\n  font-size: 0.8em;\n}\n\n.top-head-dropdown .dropdown-menu {\n  width: 350px;\n  height: 300px;\n  overflow: auto;\n}\n\n.top-head-dropdown li:last-child .top-text-block {\n  border-bottom: 0;\n}\n\n.topbar-align-center {\n  text-align: center;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvQ29tcG9uZW50cy9sYXlvdXQvRTpcXHhhbXBwXFxodGRvY3NcXGtpbmdzZXJ2aWNlXFxxcmFnZW5jeS9zcmNcXGFwcFxcQ29tcG9uZW50c1xcbGF5b3V0XFxsYXlvdXQuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL0NvbXBvbmVudHMvbGF5b3V0L2xheW91dC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLDBCQUFBO0FDQ0o7O0FER0E7RUFDSSxXQUFBO0VBQ0Esd0JBQUE7QUNBSjs7QURHQTtFQUNJLGtCQUFBO0VBQ0EsWUFBQTtBQ0FKOztBREdBO0VBQ0ksbUJBQUE7RUFDQSxrQkFBQTtBQ0FKOztBREdBO0VBQ0ksNEJBQUE7QUNBSjs7QURHQTtFQUVJLGVBQUE7QUNESjs7QURLQTtFQUNJLFdBQUE7RUFDQSxrQkFBQTtFQUNBLGNBQUE7RUFDQSxPQUFBO0VBQ0EsUUFBQTtFQUNBLFVBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtFQUNBLGtCQUFBO0VBQ0EsVUFBQTtFQUNBLG1CQUFBO0VBQ0EsYUFBQTtFQUNBLGtCQUFBO0VBQ0EsMENBQUE7QUNGSjs7QURLQSxNQUFBOztBQUNBO0VBQ0ksY0FBQTtFQUNBLGlCQUFBO0VBQ0EsV0FBQTtFQUNBLGdCQUFBO0VBQ0EsdUJBQUE7RUFDQSxXQUFBO0VBQ0EsK0JBQUE7RUFDQSxnQ0FBQTtFQUNBLGtCQUFBO0FDRko7O0FESVU7RUFDQSxXQUFBO0VBQ0EsVUFBQTtFQUNBLG1CQUFBO0VBQ0EsT0FBQTtFQUNBLE1BQUE7RUFDQSxTQUFBO0VBQ0Esa0JBQUE7QUNGVjs7QURLSTtFQUNFLGdCQUFBO0FDSE47O0FEVUk7RUFFRSxXQUFBO0VBQ0EsZ0JBQUE7QUNUTjs7QURjSTtFQUNDLFlBQUE7RUFDQyxhQUFBO0VBQ0EsY0FBQTtBQ1hOOztBRGVNO0VBQ0UsZ0JBQUE7QUNiUjs7QURpQkU7RUFDRSxrQkFBQTtBQ2RKIiwiZmlsZSI6InNyYy9hcHAvQ29tcG9uZW50cy9sYXlvdXQvbGF5b3V0LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsibGl7XHJcbiAgICBjdXJzb3I6IHBvaW50ZXIhaW1wb3J0YW50O1xyXG59XHJcblxyXG5cclxuLnJhdGluZyB7XHJcbiAgICBmbG9hdDogbGVmdDtcclxuICAgIHBhZGRpbmc6IDEwcHggIWltcG9ydGFudDtcclxufVxyXG5cclxuLm1vZGFsLWNvbmZpcm0gLm1vZGFsLWNvbnRlbnQxIHtcclxuICAgIGJvcmRlci1yYWRpdXM6IDVweDtcclxuICAgIGJvcmRlcjogbm9uZTtcclxufVxyXG5cclxuLm1vZGFsLWNvbmZpcm0gLm1vZGFsLWhlYWRlciB7XHJcbiAgICBib3JkZXItYm90dG9tOiBub25lO1xyXG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xyXG59XHJcblxyXG4ubWwtMyB7XHJcbiAgICBtYXJnaW4tbGVmdDogMHJlbSAhaW1wb3J0YW50O1xyXG59XHJcblxyXG4uY2hlY2sxIHtcclxuXHJcbiAgICBmb250LXNpemU6IDY0cHg7XHJcbiAgXHJcbn1cclxuXHJcbi5tb2RhbC1jb25maXJtIC5pY29uLWJveCB7XHJcbiAgICBjb2xvcjogI2ZmZjtcclxuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcclxuICAgIG1hcmdpbjogMCBhdXRvO1xyXG4gICAgbGVmdDogMDtcclxuICAgIHJpZ2h0OiAwO1xyXG4gICAgdG9wOiAtNDBweDtcclxuICAgIHdpZHRoOiA5NXB4O1xyXG4gICAgaGVpZ2h0OiA5NXB4O1xyXG4gICAgYm9yZGVyLXJhZGl1czogNTAlO1xyXG4gICAgei1pbmRleDogOTtcclxuICAgIGJhY2tncm91bmQ6ICM4MmNlMzQ7XHJcbiAgICBwYWRkaW5nOiAxNXB4O1xyXG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG4gICAgYm94LXNoYWRvdzogMHB4IDJweCAycHggcmdiYSgwLCAwLCAwLCAwLjEpO1xyXG59XHJcblxyXG4vKioqKiovXHJcbi50b3AtdGV4dC1ibG9ja3tcclxuICAgIGRpc3BsYXk6IGJsb2NrO1xyXG4gICAgcGFkZGluZzogM3B4IDIwcHg7XHJcbiAgICBjbGVhcjogYm90aDtcclxuICAgIGZvbnQtd2VpZ2h0OiA0MDA7XHJcbiAgICBsaW5lLWhlaWdodDogMS40Mjg1NzE0MztcclxuICAgIGNvbG9yOiAjMzMzO1xyXG4gICAgd2hpdGUtc3BhY2U6IGluaGVyaXQgIWltcG9ydGFudDtcclxuICAgIGJvcmRlci1ib3R0b206MXB4IHNvbGlkICNmNGY0ZjQ7XHJcbiAgICBwb3NpdGlvbjpyZWxhdGl2ZTtcclxuICAgICY6aG92ZXIge1xyXG4gICAgICAgICAgJjpiZWZvcmUge1xyXG4gICAgICAgICAgY29udGVudDogJyc7XHJcbiAgICAgICAgICB3aWR0aDogNHB4O1xyXG4gICAgICAgICAgYmFja2dyb3VuZDogI2YwNWExYTtcclxuICAgICAgICAgIGxlZnQ6IDA7XHJcbiAgICAgICAgICB0b3A6IDA7XHJcbiAgICAgICAgICBib3R0b206IDA7XHJcbiAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XHJcbiAgICAgIH1cclxuICAgIH1cclxuICAgICYudW5yZWFkIHtcclxuICAgICAgYmFja2dyb3VuZDojZmZjO1xyXG4gICAgICBcclxuICAgICAgLy8gJjpob3ZlciB7XHJcbiAgICAgIC8vICAgYmFja2dyb3VuZDojZmZkO1xyXG4gICAgICAvLyB9XHJcbiAgICB9XHJcbiAgICBcclxuICAgIC50b3AtdGV4dC1saWdodCB7XHJcbiAgICAgIC8vIGNvbG9yOiNjY2M7XHJcbiAgICAgIGNvbG9yOiAjOTk5O1xyXG4gICAgICBmb250LXNpemU6IDAuOGVtO1xyXG4gICAgfVxyXG4gIH0gICBcclxuICBcclxuICAudG9wLWhlYWQtZHJvcGRvd24ge1xyXG4gICAgLmRyb3Bkb3duLW1lbnUge1xyXG4gICAgIHdpZHRoOiAzNTBweDtcclxuICAgICAgaGVpZ2h0OjMwMHB4O1xyXG4gICAgICBvdmVyZmxvdzphdXRvO1xyXG4gICAgfVxyXG4gICAgXHJcbiAgICBsaTpsYXN0LWNoaWxke1xyXG4gICAgICAudG9wLXRleHQtYmxvY2sge1xyXG4gICAgICAgIGJvcmRlci1ib3R0b206MDtcclxuICAgICAgfVxyXG4gICAgfVxyXG4gIH1cclxuICAudG9wYmFyLWFsaWduLWNlbnRlciB7XHJcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XHJcbiAgfVxyXG5cclxuICAiLCJsaSB7XG4gIGN1cnNvcjogcG9pbnRlciAhaW1wb3J0YW50O1xufVxuXG4ucmF0aW5nIHtcbiAgZmxvYXQ6IGxlZnQ7XG4gIHBhZGRpbmc6IDEwcHggIWltcG9ydGFudDtcbn1cblxuLm1vZGFsLWNvbmZpcm0gLm1vZGFsLWNvbnRlbnQxIHtcbiAgYm9yZGVyLXJhZGl1czogNXB4O1xuICBib3JkZXI6IG5vbmU7XG59XG5cbi5tb2RhbC1jb25maXJtIC5tb2RhbC1oZWFkZXIge1xuICBib3JkZXItYm90dG9tOiBub25lO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59XG5cbi5tbC0zIHtcbiAgbWFyZ2luLWxlZnQ6IDByZW0gIWltcG9ydGFudDtcbn1cblxuLmNoZWNrMSB7XG4gIGZvbnQtc2l6ZTogNjRweDtcbn1cblxuLm1vZGFsLWNvbmZpcm0gLmljb24tYm94IHtcbiAgY29sb3I6ICNmZmY7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgbWFyZ2luOiAwIGF1dG87XG4gIGxlZnQ6IDA7XG4gIHJpZ2h0OiAwO1xuICB0b3A6IC00MHB4O1xuICB3aWR0aDogOTVweDtcbiAgaGVpZ2h0OiA5NXB4O1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG4gIHotaW5kZXg6IDk7XG4gIGJhY2tncm91bmQ6ICM4MmNlMzQ7XG4gIHBhZGRpbmc6IDE1cHg7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgYm94LXNoYWRvdzogMHB4IDJweCAycHggcmdiYSgwLCAwLCAwLCAwLjEpO1xufVxuXG4vKioqKiovXG4udG9wLXRleHQtYmxvY2sge1xuICBkaXNwbGF5OiBibG9jaztcbiAgcGFkZGluZzogM3B4IDIwcHg7XG4gIGNsZWFyOiBib3RoO1xuICBmb250LXdlaWdodDogNDAwO1xuICBsaW5lLWhlaWdodDogMS40Mjg1NzE0MztcbiAgY29sb3I6ICMzMzM7XG4gIHdoaXRlLXNwYWNlOiBpbmhlcml0ICFpbXBvcnRhbnQ7XG4gIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZjRmNGY0O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59XG4udG9wLXRleHQtYmxvY2s6aG92ZXI6YmVmb3JlIHtcbiAgY29udGVudDogXCJcIjtcbiAgd2lkdGg6IDRweDtcbiAgYmFja2dyb3VuZDogI2YwNWExYTtcbiAgbGVmdDogMDtcbiAgdG9wOiAwO1xuICBib3R0b206IDA7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbn1cbi50b3AtdGV4dC1ibG9jay51bnJlYWQge1xuICBiYWNrZ3JvdW5kOiAjZmZjO1xufVxuLnRvcC10ZXh0LWJsb2NrIC50b3AtdGV4dC1saWdodCB7XG4gIGNvbG9yOiAjOTk5O1xuICBmb250LXNpemU6IDAuOGVtO1xufVxuXG4udG9wLWhlYWQtZHJvcGRvd24gLmRyb3Bkb3duLW1lbnUge1xuICB3aWR0aDogMzUwcHg7XG4gIGhlaWdodDogMzAwcHg7XG4gIG92ZXJmbG93OiBhdXRvO1xufVxuLnRvcC1oZWFkLWRyb3Bkb3duIGxpOmxhc3QtY2hpbGQgLnRvcC10ZXh0LWJsb2NrIHtcbiAgYm9yZGVyLWJvdHRvbTogMDtcbn1cblxuLnRvcGJhci1hbGlnbi1jZW50ZXIge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59Il19 */");

/***/ }),

/***/ "./src/app/Components/layout/layout.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/Components/layout/layout.component.ts ***!
  \*******************************************************/
/*! exports provided: LayoutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutComponent", function() { return LayoutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_Shared_RouteDataProvider_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/Shared/RouteDataProvider.provider */ "./src/app/Shared/RouteDataProvider.provider.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var ngx_bootstrap_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ngx-bootstrap/modal */ "./node_modules/ngx-bootstrap/modal/fesm2015/ngx-bootstrap-modal.js");
/* harmony import */ var src_app_Providers_WeekEntriesProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/Providers/WeekEntriesProvider */ "./src/app/Providers/WeekEntriesProvider.ts");
/* harmony import */ var src_app_Shared_messaging_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/Shared/messaging.service */ "./src/app/Shared/messaging.service.ts");
/* harmony import */ var _angular_fire_messaging__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/fire/messaging */ "./node_modules/@angular/fire/messaging/es2015/index.js");
/* harmony import */ var src_app_Service_user_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/Service/user.service */ "./src/app/Service/user.service.ts");
/* harmony import */ var src_app_Providers_UserProvider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! src/app/Providers/UserProvider */ "./src/app/Providers/UserProvider.ts");











let LayoutComponent = class LayoutComponent {
    //   Interval = setInterval(() => {
    //     this.updateNotificationsCount();
    //  }, 30000);
    constructor(routerDataProviders, route, toastr, modalService, weekEntriesData, messagingService, angularFireMessaging, usersService, toaster, userProvider) {
        this.routerDataProviders = routerDataProviders;
        this.route = route;
        this.toastr = toastr;
        this.modalService = modalService;
        this.weekEntriesData = weekEntriesData;
        this.messagingService = messagingService;
        this.angularFireMessaging = angularFireMessaging;
        this.usersService = usersService;
        this.toaster = toaster;
        this.userProvider = userProvider;
        this.config = {
            animated: true,
            backdrop: false
        };
        this.routerDataProviders.area.subscribe(m => {
            this.currentRouter = m;
            console.log(this.currentRouter);
            console.log('here in the layout');
        });
        this.userProvider.loginName.subscribe(c => {
            this.userName = c;
        });
    }
    ngOnInit() {
        this.notification = [];
        this.userName = localStorage.getItem('userName');
        const userId = localStorage.getItem('userId');
        // this.messagingService.requestPermission(userId)
        // this.messagingService.receiveMessage();
        // this.messagingService.recevieMessageInApp();
        this.message = this.messagingService.currentMessage;
        //this.listenNotification();
    }
    ngAfterViewInit() {
        //this.updateNotificationsCount();
    }
    removeNotification(item) {
        this.usersService.RemoveNotification(item).subscribe((data) => {
            this.notification = data;
        });
    }
    updateNotificationsCount() {
        this.userId = localStorage.getItem('userId');
        if (this.userId != null) {
            this.usersService.getAllNotification(this.userId).subscribe((data) => {
                this.notification = data;
                if (this.notification.length > 0) {
                    this.notification.forEach(p => {
                        this.toaster.info(p.notification, 'Notification');
                    });
                }
            });
        }
    }
    openModal(template) {
        this.modalRef = this.modalService.show(template, this.config);
    }
    ngDocheck() {
        this.parameters = this.weekEntriesData.ratingParameters;
        console.log(this.parameters);
    }
    listenNotification() {
        this.messagingService.listenToNotifications().subscribe(msg => {
            // msg.content = JSON.parse(msg.data.content);
            console.log(msg);
        });
    }
    logout() {
        localStorage.clear();
        localStorage.removeItem('access-token');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        this.toastr.success("Logout", "Success");
        this.route.navigate(['/']);
    }
    ngOnDestroy() {
        // clearInterval(this.Interval)
        localStorage;
        this.userName;
    }
};
LayoutComponent.ctorParameters = () => [
    { type: src_app_Shared_RouteDataProvider_provider__WEBPACK_IMPORTED_MODULE_2__["RouteDataProvider"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] },
    { type: ngx_bootstrap_modal__WEBPACK_IMPORTED_MODULE_5__["BsModalService"] },
    { type: src_app_Providers_WeekEntriesProvider__WEBPACK_IMPORTED_MODULE_6__["WeekEntriesProvider"] },
    { type: src_app_Shared_messaging_service__WEBPACK_IMPORTED_MODULE_7__["MessagingService"] },
    { type: _angular_fire_messaging__WEBPACK_IMPORTED_MODULE_8__["AngularFireMessaging"] },
    { type: src_app_Service_user_service__WEBPACK_IMPORTED_MODULE_9__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] },
    { type: src_app_Providers_UserProvider__WEBPACK_IMPORTED_MODULE_10__["UserProvider"] }
];
LayoutComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-layout',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./layout.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/Components/layout/layout.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./layout.component.scss */ "./src/app/Components/layout/layout.component.scss")).default]
    })
], LayoutComponent);



/***/ }),

/***/ "./src/app/Components/layout/layout.module.ts":
/*!****************************************************!*\
  !*** ./src/app/Components/layout/layout.module.ts ***!
  \****************************************************/
/*! exports provided: LayoutModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutModule", function() { return LayoutModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _layout_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./layout-routing.module */ "./src/app/Components/layout/layout-routing.module.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");





let LayoutModule = class LayoutModule {
};
LayoutModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _layout_routing_module__WEBPACK_IMPORTED_MODULE_3__["LayoutRoutingModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["ReactiveFormsModule"],
        ]
    })
], LayoutModule);



/***/ }),

/***/ "./src/app/Models/login-form.ts":
/*!**************************************!*\
  !*** ./src/app/Models/login-form.ts ***!
  \**************************************/
/*! exports provided: LoginForm, UserModel, Users, StateModel, RegionModel, NotificationModel, FCMTokenModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginForm", function() { return LoginForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserModel", function() { return UserModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Users", function() { return Users; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateModel", function() { return StateModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RegionModel", function() { return RegionModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationModel", function() { return NotificationModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FCMTokenModel", function() { return FCMTokenModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class LoginForm {
}
class UserModel {
    constructor() {
        this.isModerator = true;
        this.isAuditor = false;
    }
}
class Users {
}
class StateModel {
}
class RegionModel {
}
class NotificationModel {
}
class FCMTokenModel {
}


/***/ }),

/***/ "./src/app/Models/mock-entries.ts":
/*!****************************************!*\
  !*** ./src/app/Models/mock-entries.ts ***!
  \****************************************/
/*! exports provided: REWARDS, DASHBOARDCOUNT, REWARDENTRIES, WEEKTASK, CITY, CATEGORY, WEEK, POSITION, RATING */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REWARDS", function() { return REWARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DASHBOARDCOUNT", function() { return DASHBOARDCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REWARDENTRIES", function() { return REWARDENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WEEKTASK", function() { return WEEKTASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CITY", function() { return CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CATEGORY", function() { return CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WEEK", function() { return WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POSITION", function() { return POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RATING", function() { return RATING; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const REWARDS = [
    { 'id': 1, 'prod_name': 'Amazon Echo Dot', 'status': 1 },
];
const DASHBOARDCOUNT = [
    { 'user_id': 1, 'total_entries': 1010, 'shortlisted_entries': 239, 'confirmed_entries': 989, 'rejected_entries': 89, 'onhold_entries': 899, 'unopened_entries': 56 },
    { 'user_id': 12, 'total_entries': 1010, 'shortlisted_entries': 239, 'confirmed_entries': 989, 'rejected_entries': 89, 'onhold_entries': 899, 'unopened_entries': 56 },
    { 'user_id': 12, 'total_entries': 1010, 'shortlisted_entries': 239, 'confirmed_entries': 989, 'rejected_entries': 89, 'onhold_entries': 899, 'unopened_entries': 56 }
];
const REWARDENTRIES = [
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 1,
        'user_id': 1
    },
    // {
    //   'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
    //   'total_rewards': '100',
    //   'confirmed_winners': '200',
    //   'pending_winners': '300',
    //   'overdue_rewards': '200',
    //   'reward_id': 1,
    //   'user_id': 1
    // },
    // {
    //   'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
    //   'total_rewards': '100',
    //   'confirmed_winners': '200',
    //   'pending_winners': '300',
    //   'overdue_rewards': '200',
    //   'reward_id': 1,
    //   'user_id': 1
    // },
    // {
    //   'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
    //   'total_rewards': '100',
    //   'confirmed_winners': '200',
    //   'pending_winners': '300',
    //   'overdue_rewards': '200',
    //   'reward_id': 1,
    //   'user_id': 1
    // },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 2,
        'user_id': 1
    },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 2,
        'user_id': 1
    },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 2,
        'user_id': 1
    },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 3,
        'user_id': 1
    },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 3,
        'user_id': 1
    },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 3,
        'user_id': 1
    },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 3,
        'user_id': 1
    },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 3,
        'user_id': 2
    },
    {
        'week': 'Week 1 (1st Sep 2019 - 7th Sep 2019)',
        'total_rewards': '100',
        'confirmed_winners': '200',
        'pending_winners': '300',
        'overdue_rewards': '200',
        'reward_id': 4,
        'user_id': 1
    },
];
const WEEKTASK = [];
// export const WEEKENTRIES: WeekEnttries[] = [
//   {
//     'id': 1, 'status': 0, 'isShortlisted': undefined, 'isRejected': undefined, 'isConfirmed': undefined, 'data_path': '../../../assets/images/gallery1.jpg', 'submited_date': '25-09-2019', 'customer_name': 'Suresh N',
//     'ratings':
//       [
//         { 'id': 1, 'rating': 0, 'name': 'Creativity' },
//         { 'id': 2, 'rating': 0, 'name': 'Sustainability' },
//         { 'id': 3, 'rating': 0, 'name': 'Usage of Colours' },
//         { 'id': 4, 'rating': 0, 'name': 'Photography' },
//         { 'id': 5, 'rating': 0, 'name': 'Nature Photography' },
//         { 'id': 6, 'rating': 0, 'name': 'Nature Photography' },
//         { 'id': 7, 'rating': 0, 'name': 'Nature Photography' }
//       ],
//     'comments': [
//       { 'id': 1, 'comment': 'Comment 1', 'commented_date': '25-10-2019 12:09:34', 'moderator_name': 'Moderator 1', 'entry_id': 1 },
//       { 'id': 2, 'comment': 'Comment 2', 'commented_date': '24-10-2019 12:09:34', 'moderator_name': 'Moderator 1', 'entry_id': 1 },
//       { 'id': 3, 'comment': 'Comment 3', 'commented_date': '23-10-2019 12:09:34', 'moderator_name': 'Moderator 1', 'entry_id': 1 },
//     ]
//   },
//   {
//     'id': 2, 'status': 0, 'isShortlisted': undefined, 'isRejected': undefined, 'isConfirmed': undefined, 'data_path': '../../../assets/images/gallery1.jpg', 'submited_date': '25-09-2019', 'customer_name': 'Suresh N',
//     'ratings': [
//       { 'id': 1, 'rating': 1, 'name': 'Creativity' },
//       { 'id': 2, 'rating': 3, 'name': 'Sustainability' },
//       { 'id': 3, 'rating': 1, 'name': 'Usage of Colours' },
//       { 'id': 4, 'rating': 5, 'name': 'Photography' },
//       { 'id': 5, 'rating': 6, 'name': 'Nature Photography' },
//       { 'id': 6, 'rating': 7, 'name': 'Nature Photography' },
//       { 'id': 7, 'rating': 8, 'name': 'Nature Photography' }
//     ],
//     'comments': []
//   },
//   {
//     'id': 3, 'status': 0, 'isShortlisted': undefined, 'isRejected': undefined, 'isConfirmed': undefined, 'data_path': '../../../assets/images/gallery1.jpg', 'submited_date': '25-09-2019', 'customer_name': 'Suresh N',
//     'ratings': [],
//     'comments': [
//       { 'id': 4, 'comment': 'Comment 1', 'commented_date': '25-10-2019 12:09:34', 'moderator_name': 'Moderator 1', 'entry_id': 2 },
//       { 'id': 5, 'comment': 'Comment 2', 'commented_date': '24-10-2019 12:09:34', 'moderator_name': 'Moderator 1', 'entry_id': 2 },
//       { 'id': 6, 'comment': 'Comment 3', 'commented_date': '23-10-2019 12:09:34', 'moderator_name': 'Moderator 1', 'entry_id': 2 },
//     ]
//   },
// ]
const CITY = [
    { 'id': 1, 'name': 'Banglore' },
    { 'id': 2, 'name': 'Belgam' },
    { 'id': 3, 'name': 'Mysore' },
    { 'id': 4, 'name': 'Mandya' },
    { 'id': 5, 'name': 'Tumkur' },
];
const CATEGORY = [
    { 'id': 1, 'name': 'Category 1' },
    { 'id': 2, 'name': 'Category 2' },
    { 'id': 3, 'name': 'Category 3' },
    { 'id': 4, 'name': 'Category 4' }
];
const WEEK = [
    { 'id': 1, 'name': 'Week 1' },
    { 'id': 2, 'name': 'Week 2' },
    { 'id': 3, 'name': 'Week 3' },
    { 'id': 4, 'name': 'Week 4' },
    { 'id': 5, 'name': 'Week 5' },
];
const POSITION = [
    { 'id': 1, 'name': 'Week 1' },
    { 'id': 2, 'name': 'Week 2' },
    { 'id': 3, 'name': 'Week 3' },
    { 'id': 4, 'name': 'Week 4' },
    { 'id': 5, 'name': 'Week 5' },
];
const RATING = [
    { 'id': 1, 'rating': 0, 'contact': 'Creativity' },
    { 'id': 2, 'rating': 0, 'contact': 'Sustainability' },
    { 'id': 3, 'rating': 0, 'contact': 'Usage of Colours' },
    { 'id': 4, 'rating': 0, 'contact': 'Photography' },
    { 'id': 5, 'rating': 0, 'contact': 'Nature Photography' },
    { 'id': 6, 'rating': 0, 'contact': 'Nature Photography' },
    { 'id': 7, 'rating': 0, 'contact': 'Nature Photography' }
];
// export const RATINGPARAMETER: RatingParameter[] = [
//   { 'id': 1, 'name': 'Creativity', 'rating': 0 },
//   { 'id': 2, 'name': 'Sustainability', 'rating': 0 },
//   { 'id': 3, 'name': 'Usage of Colours', 'rating': 0 },
//   { 'id': 4, 'name': 'Photography', 'rating': 0 },
//   { 'id': 5, 'name': 'Nature Photography', 'rating': 0 },
//   { 'id': 6, 'name': 'Nature of Phography', 'rating': 0 }
// ] 


/***/ }),

/***/ "./src/app/Models/rewards.ts":
/*!***********************************!*\
  !*** ./src/app/Models/rewards.ts ***!
  \***********************************/
/*! exports provided: Rewards, WeeksBasedEntriesData, rewardTabContent, WeekBasedTask, DashboardCountData, City, Week, Position, Category, ICompany, DocumentsModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rewards", function() { return Rewards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeeksBasedEntriesData", function() { return WeeksBasedEntriesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rewardTabContent", function() { return rewardTabContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeekBasedTask", function() { return WeekBasedTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DashboardCountData", function() { return DashboardCountData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "City", function() { return City; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Week", function() { return Week; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Position", function() { return Position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Category", function() { return Category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICompany", function() { return ICompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DocumentsModel", function() { return DocumentsModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Rewards {
}
class WeeksBasedEntriesData {
}
class rewardTabContent {
}
class WeekBasedTask {
}
class DashboardCountData {
}
class City {
}
class Week {
}
class Position {
}
class Category {
}
class ICompany {
}
class DocumentsModel {
}


/***/ }),

/***/ "./src/app/Models/sharedModel.ts":
/*!***************************************!*\
  !*** ./src/app/Models/sharedModel.ts ***!
  \***************************************/
/*! exports provided: EventType, EventStatusHandler, PreviousRouterData */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventType", function() { return EventType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventStatusHandler", function() { return EventStatusHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreviousRouterData", function() { return PreviousRouterData; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

var EventType;
(function (EventType) {
    EventType[EventType["areaChanged"] = 0] = "areaChanged";
    EventType[EventType["subAreaChanged"] = 1] = "subAreaChanged";
    EventType[EventType["queryParamChanged"] = 2] = "queryParamChanged";
})(EventType || (EventType = {}));
class EventStatusHandler {
}
class PreviousRouterData {
}


/***/ }),

/***/ "./src/app/Providers/AreaDataProvider.ts":
/*!***********************************************!*\
  !*** ./src/app/Providers/AreaDataProvider.ts ***!
  \***********************************************/
/*! exports provided: AreaDataProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AreaDataProvider", function() { return AreaDataProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class AreaDataProvider {
    constructor(areaName, routeDataProvider) {
        this.thisAreaName = "";
        this.currentAreaName = "";
        this.currentSubAreaName = "";
        this.currentQueryParam = {};
        this.firstCall = true;
        this.routeDataProvider = routeDataProvider;
        this.thisAreaName = areaName;
        this.routeDataProvider.area.subscribe(data => {
            this.currentAreaName = data;
            this.areaChanged(data, this.firstCall);
        });
        this.routeDataProvider.subArea.subscribe(data => {
            this.currentSubAreaName = data;
            this.subAreaChanged(data, this.firstCall);
        });
        this.routeDataProvider.queryParam.subscribe(data => {
            this.currentQueryParam = data;
            this.queryParamChanged(data, this.firstCall);
        });
        this.firstCall = false;
    }
}


/***/ }),

/***/ "./src/app/Providers/DashboardProvider.ts":
/*!************************************************!*\
  !*** ./src/app/Providers/DashboardProvider.ts ***!
  \************************************************/
/*! exports provided: DashboardProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DashboardProvider", function() { return DashboardProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _UserProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UserProvider */ "./src/app/Providers/UserProvider.ts");
/* harmony import */ var _Models_rewards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Models/rewards */ "./src/app/Models/rewards.ts");
/* harmony import */ var _Service_user_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Service/user.service */ "./src/app/Service/user.service.ts");





let DashboardProvider = class DashboardProvider {
    constructor(userService, userProvider, weekEntriesProvider) {
        this.userService = userService;
        this.userProvider = userProvider;
        this.weekEntriesProvider = weekEntriesProvider;
        this.rewardEntries = [];
        this.tasks = [];
        this.dashboardCount = [];
    }
    getCampaignRewards() {
        this.userService.getRewardsOfCampaign().subscribe((response) => {
            this.rewardEntries = response.data;
        });
    }
    getEntiresBasedTask() {
        this.userService.getTaskEntriesData().subscribe((response) => {
            this.tasks = response.data;
            console.log(this.tasks);
        });
    }
    getRewardsBasedData() {
        this.userService.getRewardsEntriesData().subscribe((response) => {
            this.rewardWeekBasedEntries = response;
        });
    }
    getDocuments() {
        this.userService.getRelatedDocs().subscribe((response) => {
            this.documents = response.data;
        });
    }
    getFaQs() {
        this.userService.getFaQData().subscribe((response) => {
            this.faqContent = response.data;
        });
    }
    getRewardTabContent() {
        this.rewardEntries = [];
        this.rewards.forEach(reward => {
            let loggedInUser = Number(localStorage.getItem('userId'));
            let tabsData = new _Models_rewards__WEBPACK_IMPORTED_MODULE_3__["rewardTabContent"];
            tabsData.title = reward.prod_name;
            tabsData.content = this.rewardWeekBasedEntries.filter(w => w.reward_id == reward.id);
            (reward.id == 1) ? tabsData.active = true : tabsData.active = false;
            this.rewardEntries.push(tabsData);
        });
    }
    getDashBoardCounts() {
        this.userService.getDashboardData().subscribe((response) => {
            this.dashboardCount = response;
            let loggedInUser = Number(localStorage.getItem('userId'));
            if (this.dashboardCount.length) {
                this.dashboardCount = this.dashboardCount.filter(d => d.user_id == loggedInUser);
            }
        });
    }
    checkDates(from, to) {
        let DateArray = [];
        let startDate = new Date(from);
        let endDate = new Date(to);
        while (startDate <= endDate) {
            DateArray.push(new Date(startDate));
            startDate.setDate(startDate.getDate() + 1);
        }
        let today = new Date();
        return (DateArray.find(item => { return item == today; }) || []).length > 0;
    }
    getCampaignData() {
        this.userService.getAllCampaigns().subscribe((response) => {
            this.campaign = response.data.campaigns;
            this.campaign = this.campaign.filter(c => c.id == this.userService.CampaignId);
        });
    }
};
DashboardProvider.ctorParameters = () => [
    { type: _Service_user_service__WEBPACK_IMPORTED_MODULE_4__["UserService"] },
    { type: _UserProvider__WEBPACK_IMPORTED_MODULE_2__["UserProvider"] },
    { type: DashboardProvider }
];
DashboardProvider = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], DashboardProvider);



/***/ }),

/***/ "./src/app/Providers/UserProvider.ts":
/*!*******************************************!*\
  !*** ./src/app/Providers/UserProvider.ts ***!
  \*******************************************/
/*! exports provided: UserProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserProvider", function() { return UserProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _Service_user_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Service/user.service */ "./src/app/Service/user.service.ts");
/* harmony import */ var _Models_login_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Models/login-form */ "./src/app/Models/login-form.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");







let UserProvider = class UserProvider {
    constructor(userService, toastr, router) {
        this.userService = userService;
        this.toastr = toastr;
        this.router = router;
        this.loggedInUser = new _Models_login_form__WEBPACK_IMPORTED_MODULE_3__["UserModel"]();
        this.loginName = new rxjs__WEBPACK_IMPORTED_MODULE_6__["BehaviorSubject"]("");
    }
    userLogin(LoginForm) {
        this.errorMessage = "";
        this.userService.userLogin(LoginForm).subscribe((response) => {
            if (response.success) {
                localStorage.setItem("access-token", response.data.access_token);
                localStorage.setItem("userRole", response.data.user_role);
                localStorage.setItem("userId", response.data.id);
                localStorage.setItem("userName", response.data.user_name);
                this.loginName.next(localStorage.getItem("userName"));
                let user = response.data;
                this.loading = true;
                this.loggedInUser.Token = user.access_token;
                this.loggedInUser.isAuditor = false;
                this.loggedInUser.isModerator = true;
                if (response.data.user_role == 10) {
                    this.router.navigate(['/tl-entries/tl-entries-data/']);
                }
                else if (response.data.user_role == 11) {
                    this.router.navigate(['/agency-entries/agency-entries-data/']);
                }
                else if (response.data.user_role == 12) {
                    this.router.navigate(['/admin-entries/admin-entries-data/']);
                }
                else if (response.data.user_role == 19) {
                    this.router.navigate(['/qr-agency/qr-agency-data/']);
                }
                else {
                    this.toastr.error(`Sorry, You don't have access to this module`, "Menu Programs", {
                        timeOut: 10000,
                        closeButton: true,
                        positionClass: "toast-bottom-center",
                    });
                    localStorage.clear();
                    this.loading = false;
                    return;
                }
                this.toastr.success("Logged in Successfully", "Success");
            }
            else {
                localStorage.removeItem("access-token");
                localStorage.removeItem("userRole");
                localStorage.removeItem("userId");
            }
        }, (error) => {
            if (error.status == 422) {
                this.toastr.error(" Incorrect username or password ", "Error");
                this.errorMessage = " Incorrect username or password ";
                this.loading = false;
            }
        });
    }
    updateNotificationsCount(id) {
        this.userService.getAllNotification(id).subscribe((data) => { });
    }
    getUserList() {
        this.userService.getAllUsers().subscribe((data) => {
            this.users = data;
        });
    }
    getStateList() {
        this.userService.getAllStates().subscribe((data) => {
            this.states = data;
        });
    }
    getRegionList() {
        this.userService.getAllRegions().subscribe((data) => {
            this.regions = data;
        });
    }
};
UserProvider.ctorParameters = () => [
    { type: _Service_user_service__WEBPACK_IMPORTED_MODULE_2__["UserService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] }
];
UserProvider = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: "root",
    })
], UserProvider);



/***/ }),

/***/ "./src/app/Providers/WeekEntriesProvider.ts":
/*!**************************************************!*\
  !*** ./src/app/Providers/WeekEntriesProvider.ts ***!
  \**************************************************/
/*! exports provided: WeekEntriesProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeekEntriesProvider", function() { return WeekEntriesProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _UserProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./UserProvider */ "./src/app/Providers/UserProvider.ts");
/* harmony import */ var _Service_user_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Service/user.service */ "./src/app/Service/user.service.ts");




let WeekEntriesProvider = class WeekEntriesProvider {
    constructor(userService, userProvider, weekEntriesProvider) {
        this.userService = userService;
        this.userProvider = userProvider;
        this.weekEntriesProvider = weekEntriesProvider;
        this.weekEntries = [];
        this.allWeeksEntries = [];
        this.rank = [];
    }
    getWeekEntries() {
        this.userService.getWeekEntriesData().subscribe((response) => {
            if (response.success)
                this.weekEntries = response.data;
            let userRole = localStorage.getItem('userRole');
            let user = localStorage.getItem('userId');
            if (parseInt(userRole) === 70) {
                this.weekEntries = this.weekEntries.filter(w => w.user_id == parseInt(user));
            }
            if (this.weekEntries.length) {
                this.weekEntries.forEach(e => {
                    e.isConfirmed = false;
                    e.isShortlisted = false;
                    e.isRejected = false;
                    e.notShortlist = false;
                    if (e.moderator_internal_status == 9) {
                        e.isConfirmed = true;
                    }
                    if (e.moderator_internal_status == 4) {
                        e.isShortlisted = true;
                    }
                    if (e.status == 2) {
                        e.isHolded = true;
                    }
                    if (e.moderator_internal_status == 6) {
                        e.isRejected = true;
                    }
                    if (e.moderator_internal_status == 9) {
                        // let Rank: RankModel = new RankModel;
                        // Rank.rank = e.rank;
                        // this.rank.push(Rank);
                    }
                    e.isPDF = false;
                    if (e.data_path) {
                        let path = e.data_path.split('.');
                        console.log(path);
                        if (path[path.length - 1] == 'pdf') {
                            e.isPDF = true;
                        }
                    }
                    let sumRating = 0;
                    e.rating.forEach(r => {
                        sumRating += r.rating;
                    });
                    e.ratingvalue = sumRating;
                });
            }
        });
    }
    UpdateWeekEntry(weekEntry) {
        this.userService.updateWeekEntry(weekEntry).subscribe((response) => {
            this.getWinnersEntries();
            this.getWeekEntries();
            if (response.success) {
                this.allWeeksEntries.forEach(w => {
                    if (w.id == weekEntry.id) {
                        w.isHolded = weekEntry.isHolded;
                        w.isRejected = weekEntry.isRejected;
                        w.isShortlisted = weekEntry.isShortlisted;
                        w.moderator_internal_status = weekEntry.moderator_internal_status;
                        w.points = weekEntry.points;
                        w.rating = weekEntry.rating;
                        w.ratingvalue = weekEntry.ratingvalue;
                        w.status = weekEntry.status;
                        w.submitted_date = weekEntry.submitted_date;
                        w.title = weekEntry.title;
                        w.user_id = weekEntry.user_id;
                        w.winningtime = weekEntry.winningtime;
                        w.comments = weekEntry.comments;
                        if (w.moderator_internal_status == 9) {
                            w.isConfirmed = true;
                        }
                        if (w.moderator_internal_status == 4) {
                            w.isShortlisted = true;
                            w.notShortlist = false;
                        }
                        if (w.status == 2) {
                            w.isHolded = true;
                        }
                        if (w.moderator_internal_status == 6) {
                            w.isRejected = true;
                        }
                        w.isPDF = false;
                        if (w.data_path) {
                            let path = w.data_path.split('.');
                            console.log(path);
                            if (path[path.length - 1] == 'pdf') {
                                w.isPDF = true;
                            }
                        }
                    }
                });
                this.weekEntries.forEach(w => {
                    if (w.id == weekEntry.id) {
                        w.isHolded = weekEntry.isHolded;
                        w.isRejected = weekEntry.isRejected;
                        w.isShortlisted = weekEntry.isShortlisted;
                        w.moderator_internal_status = weekEntry.moderator_internal_status;
                        w.points = weekEntry.points;
                        w.rating = weekEntry.rating;
                        w.ratingvalue = weekEntry.ratingvalue;
                        w.status = weekEntry.status;
                        w.submitted_date = weekEntry.submitted_date;
                        w.title = weekEntry.title;
                        w.user_id = weekEntry.user_id;
                        w.winningtime = weekEntry.winningtime;
                        w.comments = weekEntry.comments;
                        w.isPDF = false;
                        if (w.data_path) {
                            let path = w.data_path.split('.');
                            console.log(path);
                            if (path[path.length - 1] == 'pdf') {
                                w.isPDF = true;
                            }
                        }
                        if (w.moderator_internal_status == 9) {
                            w.isConfirmed = true;
                        }
                        if (w.moderator_internal_status == 4) {
                            w.isShortlisted = true;
                            w.notShortlist = false;
                        }
                        if (w.status == 2) {
                            w.isHolded = true;
                        }
                        if (w.moderator_internal_status == 6) {
                            w.isRejected = true;
                        }
                    }
                });
            }
        });
    }
    getWinnersEntries() {
        this.userService.getWeekEntriesData()
            .subscribe((response) => {
            if (response.success) {
                this.allWeeksEntries = response.data;
                let userRole = localStorage.getItem('userRole');
                let user = localStorage.getItem('userId');
                if (parseInt(userRole) === 70) {
                    this.allWeeksEntries = this.allWeeksEntries.filter(w => w.user_id == parseInt(user));
                }
                if (this.allWeeksEntries.length) {
                    this.allWeeksEntries.forEach(e => {
                        e.isConfirmed = false;
                        e.isShortlisted = false;
                        e.isRejected = false;
                        e.isHolded = false;
                        e.notShortlist = false;
                        if (e.moderator_internal_status == 9) {
                            e.isConfirmed = true;
                            e.editRating = true;
                        }
                        if (e.moderator_internal_status == 4) {
                            e.isShortlisted = true;
                        }
                        if (e.status == 2) {
                            e.isHolded = true;
                        }
                        if (e.moderator_internal_status == 6) {
                            e.isRejected = true;
                        }
                        e.isPDF = false;
                        if (e.data_path) {
                            let path = e.data_path.split('.');
                            console.log(path);
                            if (path[path.length - 1] == 'pdf') {
                                e.isPDF = true;
                            }
                        }
                        let sumRating = 0;
                        e.rating.forEach(r => {
                            sumRating += r.rating;
                        });
                        e.ratingvalue = sumRating;
                    });
                }
            }
        });
    }
    getEntiesCity() {
        this.userService.getCityData().subscribe((response) => {
            this.cities = response.data;
        });
    }
    getWeekEntriesByStatus(item) {
        let userRole = localStorage.getItem('userRole');
        let user = localStorage.getItem('userId');
        // if (parseInt(userRole) === 70) {
        //   this.allWeeksEntries = this.allWeeksEntries.filter(w => w.user_id == parseInt(user));
        // }
        console.log(typeof (item));
        switch (item) {
            case '1':
                this.weekEntries = this.allWeeksEntries;
                break;
            case '2':
                this.weekEntries = this.allWeeksEntries.filter(e => e.moderator_internal_status == 4);
                break;
            case '3':
                this.weekEntries = this.allWeeksEntries.filter(e => e.status == 2);
                break;
            case '5':
                this.weekEntries = this.allWeeksEntries.filter(e => e.moderator_internal_status == 6);
                break;
            case '4':
                this.weekEntries = this.allWeeksEntries.filter(e => e.moderator_internal_status == 9);
                break;
            case '6':
                this.weekEntries = this.allWeeksEntries.filter(e => e.moderator_internal_status == 3);
                break;
        }
    }
    getEntiesWeeks() {
        this.userService.getWeeks().subscribe((response) => {
            this.weeks = response;
        });
    }
    getEntiesPosition() {
        this.userService.getPositionData().subscribe((response) => {
            this.position = response;
        });
    }
    getEntriesCategory() {
        this.userService.getCategory().subscribe((response) => {
            this.category = response;
        });
    }
    getRatingOfEntries() {
        this.userService.getRatingEntries().subscribe((response) => {
            this.ratings = response;
        });
    }
    getRatingParameter() {
        this.userService.getRatingParameter().subscribe((response) => {
            this.ratingParameters = response;
            this.ratingParameters.forEach(r => {
                r.paramter_id == r.id;
            });
        });
    }
    ;
    getSelectedEntryById(id) {
        this.selectedEntries = this.weekEntries.find(w => w.id == id);
        return this.selectedEntries;
    }
    getCityBasedRecord(cityId) {
        if (cityId != -1) {
            this.weekEntries = this.allWeeksEntries.filter(w => w.city_id == parseInt(cityId));
        }
    }
    getRankBasedRecord(rank) {
        this.weekEntries = this.allWeeksEntries.filter(w => w.rank == parseInt(rank));
    }
    getDateBasedRecords(date1, date2) {
        // this.weekEntries = this.allWeeksEntries.filter(w => (new Date(w.submitted_date) >= new Date(date1)) && (new Date(w.submitted_date) <= new Date(date2)))
        // console.log(this.weekEntries); 
        let tempDate = new Date(date2);
        date2 = tempDate.setDate(tempDate.getDate() + 1);
        this.weekEntries = this.allWeeksEntries.filter(m => new Date(m.submitted_date) >= new Date(date1) && new Date(m.submitted_date) <= date2);
    }
};
WeekEntriesProvider.ctorParameters = () => [
    { type: _Service_user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"] },
    { type: _UserProvider__WEBPACK_IMPORTED_MODULE_2__["UserProvider"] },
    { type: WeekEntriesProvider }
];
WeekEntriesProvider = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], WeekEntriesProvider);



/***/ }),

/***/ "./src/app/Service/Http/HttpCacheService.ts":
/*!**************************************************!*\
  !*** ./src/app/Service/Http/HttpCacheService.ts ***!
  \**************************************************/
/*! exports provided: HttpCacheService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpCacheService", function() { return HttpCacheService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HttpCacheService = class HttpCacheService {
    constructor() {
        this.requests = {};
    }
    put(url, response) {
        this.requests[url] = response;
    }
    get(url) {
        return this.requests[url];
    }
    invalidateCache() {
        this.requests = {};
    }
};
HttpCacheService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], HttpCacheService);



/***/ }),

/***/ "./src/app/Service/Http/cache.interceptor.ts":
/*!***************************************************!*\
  !*** ./src/app/Service/Http/cache.interceptor.ts ***!
  \***************************************************/
/*! exports provided: CacheInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CacheInterceptor", function() { return CacheInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _HttpCacheService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./HttpCacheService */ "./src/app/Service/Http/HttpCacheService.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");







let CacheInterceptor = class CacheInterceptor {
    constructor(cacheService, toasterService) {
        this.cacheService = cacheService;
        this.toasterService = toasterService;
    }
    intercept(req, next) {
        // pass along non-cacheable requests and invalidate cache  
        if (req.method !== 'GET') {
            console.log(`Invalidating cache: ${req.method} ${req.url}`);
            this.cacheService.invalidateCache();
            return next.handle(req);
        }
        // attempt to retrieve a cached response  
        const cachedResponse = this.cacheService.get(req.url);
        // return cached response  
        if (cachedResponse) {
            let path = cachedResponse.url.split('/');
            let b = path[path.length - 1].split("?")[0];
            let c = path[path.length - 1];
            if (b != 'getallnotifications') {
                console.log(path);
                console.log(`Returning a cached response: ${cachedResponse.url}`);
                console.log(cachedResponse);
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(cachedResponse);
            }
        }
        // send request to server and add response to cache  
        return next.handle(req)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["tap"])(event => {
            if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpResponse"]) {
                console.log(`Adding item to cache: ${req.url}`);
                this.cacheService.put(req.url, event);
            }
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            console.log(err);
            if (err instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpErrorResponse"]) {
                switch (err.status) {
                    case 401:
                    case 403:
                        this.toasterService.error("Un-Authorized Request", "Error", {
                            timeOut: 10000,
                        });
                        //this.router.navigate(['/']);
                        window.location.href = '/';
                        break;
                    case 404:
                        this.toasterService.error(err.message, "Error", {
                            timeOut: 10000,
                        });
                        break;
                    case 500:
                        this.toasterService.error("Internal Server Error - Data is not saved", "Error", {
                            timeOut: 10000,
                        });
                        break;
                }
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(err);
        }));
    }
};
CacheInterceptor.ctorParameters = () => [
    { type: _HttpCacheService__WEBPACK_IMPORTED_MODULE_5__["HttpCacheService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_6__["ToastrService"] }
];
CacheInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], CacheInterceptor);



/***/ }),

/***/ "./src/app/Service/SiteAuth/global.service.ts":
/*!****************************************************!*\
  !*** ./src/app/Service/SiteAuth/global.service.ts ***!
  \****************************************************/
/*! exports provided: GlobalService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalService", function() { return GlobalService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");



let GlobalService = class GlobalService {
    constructor() {
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].production == true) {
            this.apiHostUrl = 'https://api1.bud4trade.bigcityexperiences.com/v1';
            // this.apiHostUrl = 'https://api1.staging4.bigcityvoucher.co.in/v1';
            //this.apiHostUrl = 'http://localhost/kingservice/api/web/v1';
        }
        else {
            this.apiHostUrl = 'https://api1.bud4trade.bigcityexperiences.com/v1';
            //this.apiHostUrl = 'https://api1.staging4.bigcityvoucher.co.in/v1';
            //this.apiHostUrl = 'http://localhost/kingservice/api/web/v1';
        }
    }
};
GlobalService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], GlobalService);



/***/ }),

/***/ "./src/app/Service/user.service.ts":
/*!*****************************************!*\
  !*** ./src/app/Service/user.service.ts ***!
  \*****************************************/
/*! exports provided: UserService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserService", function() { return UserService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_internal_observable_throwError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/internal/observable/throwError */ "./node_modules/rxjs/internal/observable/throwError.js");
/* harmony import */ var rxjs_internal_observable_throwError__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(rxjs_internal_observable_throwError__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _SiteAuth_global_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./SiteAuth/global.service */ "./src/app/Service/SiteAuth/global.service.ts");
/* harmony import */ var _Models_mock_entries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Models/mock-entries */ "./src/app/Models/mock-entries.ts");







// Mock For Rewards;

const login = '/admin/login';
const reward = '/staff/getrewardslist';
const collagesData = '/staff/getcollageassigneddata';
const updateWinnerEntry = '/staff/updateentry';
const parameters = '/staff/ratingparameters';
const cityAPI = '/staff/getcitylist';
const tasksAPI = '/staff/moderatortasks';
const documentAPI = '/staff/campaigndocumentlist';
const campaignAPI = '/staff/campaigns';
const faqAPI = '/staff/campaignfaqlist';
const user = '/hub-admin/getassignedusers';
const state = '/hub-admin/getallstates';
const template = '/hub-admin/gettemplates';
const brand = '/hub-admin/getallmenubrand';
const request = '/hub-admin/getallmenurequest';
const agentrequest = '/hub-admin/getagentrequestdetails';
const requestTrans = '/hub-admin/getmenutransactionsbyid';
const region = '/hub-admin/getallregion';
const assign = '/hub-admin/assigntoagent';
const reassign = '/hub-admin/reassigntoagent';
const notification = '/hub-admin/getallnotifications';
const removeNotification = '/hub-admin/removenotification';
const updatefcmtoken = '/hub-admin/updatefcmtoken';
const requestupdate = '/hub-admin/agentrequestupdate';
const bulkrecord = '/hub-admin/getbulkdetails';
const BULK_ASSIGNED_API = '/hub-admin/bulkassign';
const getqragentrequestdetails = '/hub-admin/getqragentrequestdetails';
const getuploadedlink = '/hub-admin/getuploadedlink';
const digitalmenuuploadlink = '/hub-admin/digitalmenuuploadlink';
let UserService = class UserService {
    constructor(http, siteAuth) {
        this.http = http;
        this.siteAuth = siteAuth;
        this.CampaignId = 1;
    }
    getHeaders() {
        return new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('access-token')
        });
    }
    userLogin(LoginForm) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + login;
        let body = JSON.stringify({ LoginForm });
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getRewardsOfCampaign() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + reward + '?campaign_id=' + this.CampaignId;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getRewardsEntriesData() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(_Models_mock_entries__WEBPACK_IMPORTED_MODULE_7__["REWARDENTRIES"]);
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + collagesData;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getWeekEntriesData() {
        // console.log(WeekEnttries);
        // return of(WEEKENTRIES);
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + collagesData;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    updateWeekEntry(entry) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + updateWinnerEntry;
        let body = JSON.stringify(entry);
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getTaskEntriesData() {
        // return of(WEEKTASK);
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + tasksAPI;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getDashboardData() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(_Models_mock_entries__WEBPACK_IMPORTED_MODULE_7__["DASHBOARDCOUNT"]);
    }
    getRelatedDocs() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + documentAPI + '?campaign_id=' + this.CampaignId;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getFaQData() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + faqAPI + '?campaign_id=' + this.CampaignId;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllCampaigns() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + campaignAPI;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getCityData() {
        //return of(CITY)
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + cityAPI;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getRatingEntries() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(_Models_mock_entries__WEBPACK_IMPORTED_MODULE_7__["RATING"]);
    }
    getPositionData() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(_Models_mock_entries__WEBPACK_IMPORTED_MODULE_7__["POSITION"]);
    }
    getWeeks() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(_Models_mock_entries__WEBPACK_IMPORTED_MODULE_7__["WEEK"]);
    }
    getCategory() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(_Models_mock_entries__WEBPACK_IMPORTED_MODULE_7__["CATEGORY"]);
    }
    getRatingParameter() {
        //return of (RATING)
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + parameters;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllUsers() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + user;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllStates() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + state;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllTemplate() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + template;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllNotification(UserId) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + notification + '?user_id=' + UserId;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    RemoveNotification(data) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + removeNotification;
        let body = data;
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllBrands() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + brand;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllTemplateMenuRequest() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + request + "?calendar_year=" + 2021;
        ;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllTemplateMenuRequestByAgent() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + agentrequest + "?calendar_year=" + 2021;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllTemplateMenuRequestTransaction(id) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + requestTrans + "?menu_id=" + id;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getAllRegions() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + region;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data.regions;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getBulkCount() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + bulkrecord;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    BulkAssignedRecords(bulkassignvalue, user_id) {
        debugger;
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + BULK_ASSIGNED_API;
        let body = JSON.stringify({
            "bulkassignvalue": bulkassignvalue,
            "assigned_user": user_id
        });
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    AssignRecords(assignRecord) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + assign;
        let body = assignRecord;
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    agentRequestUpdate(assignRecord) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + requestupdate;
        let body = assignRecord;
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    ReassignRecords(assignRecord) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + reassign;
        let body = assignRecord;
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    UpdateFcmToken(data) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + updatefcmtoken;
        let body = data;
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    handleError(response) {
        let errorMessage = {};
        // Connection error
        console.log(response);
        if (response.status === 0) {
            errorMessage = {
                success: false,
                status: 0,
                data: 'Sorry, there was a connection error occurred. Please try again.'
            };
        }
        else {
            errorMessage = response.error;
        }
        return Object(rxjs_internal_observable_throwError__WEBPACK_IMPORTED_MODULE_4__["throwError"])(errorMessage);
    }
    getQrAgentRequest() {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + getqragentrequestdetails;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    getQRUploadedLink(menu_request_id) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + getuploadedlink + '?menu_request_id=' + menu_request_id;
        return this.http.get(apiUrl, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
    postQRDigitalMenuUploadLink(menuRequestID, searchTextMenu, outlet_user_id) {
        let headers = this.getHeaders();
        let apiUrl = this.siteAuth.apiHostUrl + digitalmenuuploadlink;
        let body = { digital_menu_link: searchTextMenu, menu_request_id: menuRequestID, outlet_user_id: outlet_user_id };
        return this.http.post(apiUrl, body, { headers: headers })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            return response.data;
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])(this.handleError));
    }
};
UserService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _SiteAuth_global_service__WEBPACK_IMPORTED_MODULE_6__["GlobalService"] }
];
UserService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], UserService);



/***/ }),

/***/ "./src/app/Shared/AuthGuard.ts":
/*!*************************************!*\
  !*** ./src/app/Shared/AuthGuard.ts ***!
  \*************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let AuthGuard = class AuthGuard {
    constructor(router) {
        this.router = router;
    }
    canActivate(route, state) {
        let url = state.url;
        return this.checkLogin(url);
    }
    canActivateChild(route, state) {
        return this.canActivate(route, state);
    }
    checkLogin(url) {
        if (localStorage.getItem('access-token')) {
            // logged in so return true
            return true;
        }
        // Navigate to the login page with extras
        this.router.navigate(['/'], { queryParams: { r: url } });
        return false;
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AuthGuard);



/***/ }),

/***/ "./src/app/Shared/RouteDataProvider.provider.ts":
/*!******************************************************!*\
  !*** ./src/app/Shared/RouteDataProvider.provider.ts ***!
  \******************************************************/
/*! exports provided: RouteDataProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouteDataProvider", function() { return RouteDataProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");





let RouteDataProvider = class RouteDataProvider {
    constructor(router, activateRoute) {
        this.router = router;
        this.activateRoute = activateRoute;
        this.previousUrl = undefined;
        this.area = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"]("");
        this.subArea = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"]("");
        this.queryParam = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"]({});
        this._listners = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this._subAreaListners = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.share = this.subArea.asObservable();
        this.router.events.subscribe(data => {
            if (data instanceof _angular_router__WEBPACK_IMPORTED_MODULE_2__["NavigationEnd"]) {
                let urlParts = data.urlAfterRedirects.split("?");
                let url = urlParts[0] || "";
                let query = urlParts[1] || "";
                if (url.length > 0) {
                    let parts = url.split("/");
                    parts.splice(0, 1);
                    let oldArea = this.area.getValue();
                    let newArea = parts[0] || "";
                    if (newArea !== oldArea) {
                        this.area.next(newArea);
                    }
                    let oldSubArea = this.subArea.getValue();
                    let newSubArea = parts[1] || "";
                    if (newSubArea !== oldSubArea) {
                        this.subArea.next(newSubArea);
                    }
                    if (parts[2] && parts[2].length > 0) {
                        //Handle landing page request, convert to query params
                        query = "id=" + parts[2];
                    }
                }
                if (query.length > 0) {
                    this.queryParam.next(this.queryStringToJSON(query));
                }
                else {
                    this.queryParam.next({});
                }
                this._subAreaListners.next(this.queryParam.getValue());
                console.log("Area: " + this.area.getValue() + " Sub-Area: " + this.subArea.getValue() + " Query:" + JSON.stringify(this.queryParam.getValue()));
            }
        });
    }
    queryStringToJSON(queryString) {
        var pairs = queryString.split('&');
        var result = {};
        pairs.forEach(function (pair) {
            pair = pair.split('=');
            result[pair[0]] = decodeURIComponent(pair[1] || '');
        });
        return result;
    }
    sendTo(requiredData) {
        this._listners.next(requiredData);
    }
    listen() {
        return this._listners.asObservable();
    }
    subAreaListen() {
        return this._subAreaListners.asObservable();
    }
};
RouteDataProvider.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] }
];
RouteDataProvider = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], RouteDataProvider);



/***/ }),

/***/ "./src/app/Shared/UserDataProvider.ts":
/*!********************************************!*\
  !*** ./src/app/Shared/UserDataProvider.ts ***!
  \********************************************/
/*! exports provided: UserDataProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserDataProvider", function() { return UserDataProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _RouteDataProvider_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RouteDataProvider.provider */ "./src/app/Shared/RouteDataProvider.provider.ts");
/* harmony import */ var _Providers_AreaDataProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Providers/AreaDataProvider */ "./src/app/Providers/AreaDataProvider.ts");
/* harmony import */ var _Models_sharedModel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Models/sharedModel */ "./src/app/Models/sharedModel.ts");
/* harmony import */ var _Providers_UserProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Providers/UserProvider */ "./src/app/Providers/UserProvider.ts");
/* harmony import */ var _Providers_DashboardProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Providers/DashboardProvider */ "./src/app/Providers/DashboardProvider.ts");
/* harmony import */ var _Providers_WeekEntriesProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Providers/WeekEntriesProvider */ "./src/app/Providers/WeekEntriesProvider.ts");








let UserDataProvider = class UserDataProvider extends _Providers_AreaDataProvider__WEBPACK_IMPORTED_MODULE_3__["AreaDataProvider"] {
    constructor(routerDataProvider, userProviders, dashBoardProviders, weekEntriesProviders) {
        super('Entries', routerDataProvider);
        this.routerDataProvider = routerDataProvider;
        this.userProviders = userProviders;
        this.dashBoardProviders = dashBoardProviders;
        this.weekEntriesProviders = weekEntriesProviders;
    }
    areaChanged(newArea, firstCall) {
        if (firstCall) {
            return;
        }
    }
    subAreaChanged(newSubArea, firstCall) {
        if (firstCall || newSubArea == this.currentAreaName) {
            return;
        }
        this.eventHandler({ type: _Models_sharedModel__WEBPACK_IMPORTED_MODULE_4__["EventType"].subAreaChanged });
    }
    queryParamChanged(newQueryParams, firstCall) {
        if (firstCall) {
            return;
        }
        if (newQueryParams.id !== undefined) {
            this.eventHandler({ type: _Models_sharedModel__WEBPACK_IMPORTED_MODULE_4__["EventType"].queryParamChanged });
        }
        else {
            this.eventHandler({ type: _Models_sharedModel__WEBPACK_IMPORTED_MODULE_4__["EventType"].areaChanged });
        }
    }
    urlMaker(data) {
        return "";
    }
    eventHandler(eventData) {
        switch (eventData.type) {
            case _Models_sharedModel__WEBPACK_IMPORTED_MODULE_4__["EventType"].queryParamChanged:
                console.log('Query Param Changed', this.currentQueryParam);
                break;
            case _Models_sharedModel__WEBPACK_IMPORTED_MODULE_4__["EventType"].areaChanged:
                console.log('Query Param Changed', this.currentAreaName);
            case _Models_sharedModel__WEBPACK_IMPORTED_MODULE_4__["EventType"].subAreaChanged:
                console.log('Sub Area Changed', this.currentSubAreaName);
                switch (this.currentSubAreaName) {
                    case "entries-data":
                        console.log("i am inside entries");
                        this.weekEntriesProviders.getWeekEntries();
                        this.weekEntriesProviders.getEntriesCategory();
                        this.weekEntriesProviders.getWinnersEntries();
                        this.weekEntriesProviders.getEntiesWeeks();
                        this.weekEntriesProviders.getEntiesCity();
                        this.weekEntriesProviders.getEntiesPosition();
                        this.dashBoardProviders.getCampaignRewards();
                        this.dashBoardProviders.getDashBoardCounts();
                        this.weekEntriesProviders.getRatingOfEntries();
                        this.weekEntriesProviders.getRatingParameter();
                        this.dashBoardProviders.getEntiresBasedTask();
                        console.log(this.weekEntriesProviders);
                        break;
                }
        }
    }
};
UserDataProvider.ctorParameters = () => [
    { type: _RouteDataProvider_provider__WEBPACK_IMPORTED_MODULE_2__["RouteDataProvider"] },
    { type: _Providers_UserProvider__WEBPACK_IMPORTED_MODULE_5__["UserProvider"] },
    { type: _Providers_DashboardProvider__WEBPACK_IMPORTED_MODULE_6__["DashboardProvider"] },
    { type: _Providers_WeekEntriesProvider__WEBPACK_IMPORTED_MODULE_7__["WeekEntriesProvider"] }
];
UserDataProvider = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], UserDataProvider);



/***/ }),

/***/ "./src/app/Shared/messaging.service.ts":
/*!*********************************************!*\
  !*** ./src/app/Shared/messaging.service.ts ***!
  \*********************************************/
/*! exports provided: MessagingService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MessagingService", function() { return MessagingService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_fire_database__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/fire/database */ "./node_modules/@angular/fire/database/es2015/index.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_fire_messaging__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/fire/messaging */ "./node_modules/@angular/fire/messaging/es2015/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _Service_user_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Service/user.service */ "./src/app/Service/user.service.ts");
/* harmony import */ var _Models_login_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Models/login-form */ "./src/app/Models/login-form.ts");








let MessagingService = class MessagingService {
    constructor(angularFireDB, angularFireAuth, angularFireMessaging, userService) {
        this.angularFireDB = angularFireDB;
        this.angularFireAuth = angularFireAuth;
        this.angularFireMessaging = angularFireMessaging;
        this.userService = userService;
        this.currentMessage = new rxjs__WEBPACK_IMPORTED_MODULE_5__["BehaviorSubject"](null);
        this.token = new rxjs__WEBPACK_IMPORTED_MODULE_5__["BehaviorSubject"]('');
        this.angularFireMessaging.messaging.subscribe((_messaging) => {
            _messaging.onMessage = _messaging.onMessage.bind(_messaging);
            _messaging._next = (payload) => {
                console.log(payload);
            };
            _messaging.onMessage((payload) => {
                this.messaging = payload.message();
                console.log(this.messaging);
            });
            _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
        });
    }
    /**
     * update token in firebase database
     *
     * @param userId userId as a key
     * @param token token as a value
     */
    updateToken(userId, token) {
        // we can change this function to request our backend service
        let fcmModel = new _Models_login_form__WEBPACK_IMPORTED_MODULE_7__["FCMTokenModel"];
        fcmModel.user_id = userId;
        fcmModel.fcm_token = token;
        this.userService.UpdateFcmToken(fcmModel).subscribe((data) => {
            if (data) {
                return;
            }
        });
    }
    /**
     * request permission for notification from firebase cloud messaging
     *
     * @param userId userId
     */
    requestPermission(userId) {
        this.angularFireMessaging.requestToken.subscribe((token) => {
            console.log(token);
            this.token.next(token);
            //this.updateToken(userId, token);
        }, (err) => {
            console.error('Unable to get permission to notify.', err);
        });
    }
    /**
     * hook method when new notification received in foreground
     */
    receiveMessage() {
        this.angularFireMessaging
            .messaging.subscribe((message) => {
            message.onMessage((payload) => {
                this.messaging = payload.message();
            });
        });
    }
    recevieMessageInApp() {
        this.angularFireMessaging.messages
            .subscribe((message) => {
            console.log(message);
        });
    }
    listenToNotifications() {
        return this.angularFireMessaging.messages;
    }
};
MessagingService.ctorParameters = () => [
    { type: _angular_fire_database__WEBPACK_IMPORTED_MODULE_2__["AngularFireDatabase"] },
    { type: _angular_fire_auth__WEBPACK_IMPORTED_MODULE_3__["AngularFireAuth"] },
    { type: _angular_fire_messaging__WEBPACK_IMPORTED_MODULE_4__["AngularFireMessaging"] },
    { type: _Service_user_service__WEBPACK_IMPORTED_MODULE_6__["UserService"] }
];
MessagingService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], MessagingService);



/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _Components_layout_layout_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Components/layout/layout.component */ "./src/app/Components/layout/layout.component.ts");
/* harmony import */ var _Shared_AuthGuard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Shared/AuthGuard */ "./src/app/Shared/AuthGuard.ts");





const routes = [
    {
        path: "",
        component: _Components_layout_layout_component__WEBPACK_IMPORTED_MODULE_3__["LayoutComponent"],
        children: [
            {
                path: "",
                loadChildren: "./Components/login/login.module#LoginModule",
            },
            {
                path: "",
                canActivate: [_Shared_AuthGuard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]],
                loadChildren: "./Components/TL-Entries/tl-entries.module#TLEntriesModule",
            },
            {
                path: "",
                canActivate: [_Shared_AuthGuard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]],
                loadChildren: "./Components/QR-Agency/qr-agency.module#QRAgencyModule",
            },
            {
                path: "",
                canActivate: [_Shared_AuthGuard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]],
                loadChildren: "./Components/Agency-Entries/agency-entries.module#AgencyEntriesModule",
            },
            {
                path: "",
                canActivate: [_Shared_AuthGuard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]],
                loadChildren: "./Components/Admin-Entries/admin-entries.module#AdminEntriesModule",
            },
        ],
    },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]],
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.title = 'entries-panel';
    }
    ngOnInit() {
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _Components_layout_layout_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Components/layout/layout.component */ "./src/app/Components/layout/layout.component.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _Components_Entries_entries_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Components/Entries/entries.module */ "./src/app/Components/Entries/entries.module.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _Shared_RouteDataProvider_provider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Shared/RouteDataProvider.provider */ "./src/app/Shared/RouteDataProvider.provider.ts");
/* harmony import */ var ngx_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ngx-bootstrap */ "./node_modules/ngx-bootstrap/esm5/ngx-bootstrap.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ngx_rating__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ngx-rating */ "./node_modules/ngx-rating/index.js");
/* harmony import */ var ngx_rating__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(ngx_rating__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var ngx_bootstrap_datepicker__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ngx-bootstrap/datepicker */ "./node_modules/ngx-bootstrap/datepicker/fesm2015/ngx-bootstrap-datepicker.js");
/* harmony import */ var _Shared_AuthGuard__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Shared/AuthGuard */ "./src/app/Shared/AuthGuard.ts");
/* harmony import */ var _Components_layout_layout_module__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Components/layout/layout.module */ "./src/app/Components/layout/layout.module.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ngx_ui_loader__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ngx-ui-loader */ "./node_modules/ngx-ui-loader/fesm2015/ngx-ui-loader.js");
/* harmony import */ var _Service_Http_cache_interceptor__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./Service/Http/cache.interceptor */ "./src/app/Service/Http/cache.interceptor.ts");
/* harmony import */ var _angular_fire_database__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/fire/database */ "./node_modules/@angular/fire/database/es2015/index.js");
/* harmony import */ var _angular_fire_auth__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @angular/fire/auth */ "./node_modules/@angular/fire/auth/es2015/index.js");
/* harmony import */ var _angular_fire_messaging__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @angular/fire/messaging */ "./node_modules/@angular/fire/messaging/es2015/index.js");
/* harmony import */ var _angular_fire__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/fire */ "./node_modules/@angular/fire/es2015/index.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _Shared_messaging_service__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./Shared/messaging.service */ "./src/app/Shared/messaging.service.ts");
/* harmony import */ var angular_6_datatable__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! angular-6-datatable */ "./node_modules/angular-6-datatable/index.js");
/* harmony import */ var angular_6_datatable__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(angular_6_datatable__WEBPACK_IMPORTED_MODULE_26__);



























let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"],
            _Components_layout_layout_component__WEBPACK_IMPORTED_MODULE_5__["LayoutComponent"],
            ngx_bootstrap__WEBPACK_IMPORTED_MODULE_11__["RatingComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__["BrowserAnimationsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClientModule"],
            _Components_layout_layout_module__WEBPACK_IMPORTED_MODULE_16__["LayoutModule"],
            _Components_Entries_entries_module__WEBPACK_IMPORTED_MODULE_7__["EntriesModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_12__["FormsModule"],
            ngx_rating__WEBPACK_IMPORTED_MODULE_13__["RatingModule"],
            ngx_ui_loader__WEBPACK_IMPORTED_MODULE_18__["NgxUiLoaderModule"],
            angular_6_datatable__WEBPACK_IMPORTED_MODULE_26__["DataTableModule"],
            ngx_bootstrap__WEBPACK_IMPORTED_MODULE_11__["ModalModule"].forRoot(),
            ngx_bootstrap__WEBPACK_IMPORTED_MODULE_11__["TabsModule"].forRoot(),
            ngx_toastr__WEBPACK_IMPORTED_MODULE_8__["ToastrModule"].forRoot({
                maxOpened: 1,
                autoDismiss: true
            }),
            ngx_bootstrap_datepicker__WEBPACK_IMPORTED_MODULE_14__["BsDatepickerModule"].forRoot(),
            _angular_fire_database__WEBPACK_IMPORTED_MODULE_20__["AngularFireDatabaseModule"],
            _angular_fire_auth__WEBPACK_IMPORTED_MODULE_21__["AngularFireAuthModule"],
            _angular_fire_messaging__WEBPACK_IMPORTED_MODULE_22__["AngularFireMessagingModule"],
            _angular_fire__WEBPACK_IMPORTED_MODULE_23__["AngularFireModule"].initializeApp(src_environments_environment__WEBPACK_IMPORTED_MODULE_24__["environment"].firebase),
        ],
        providers: [
            {
                provide: _angular_common__WEBPACK_IMPORTED_MODULE_17__["LocationStrategy"],
                useClass: _angular_common__WEBPACK_IMPORTED_MODULE_17__["HashLocationStrategy"]
            },
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HTTP_INTERCEPTORS"], useClass: _Service_Http_cache_interceptor__WEBPACK_IMPORTED_MODULE_19__["CacheInterceptor"], multi: true },
            _Shared_RouteDataProvider_provider__WEBPACK_IMPORTED_MODULE_10__["RouteDataProvider"], _Shared_AuthGuard__WEBPACK_IMPORTED_MODULE_15__["AuthGuard"], _Shared_messaging_service__WEBPACK_IMPORTED_MODULE_25__["MessagingService"], _angular_common__WEBPACK_IMPORTED_MODULE_17__["AsyncPipe"]
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyBnYdfxDJ5866WHabwrbToKZN7gTUe4wRw",
        authDomain: "hp-race.firebaseapp.com",
        databaseURL: "https://hp-race.firebaseio.com",
        projectId: "hp-race",
        storageBucket: "hp-race.appspot.com",
        messagingSenderId: "479186612041",
        appId: "1:479186612041:web:f1826b801885adca28b498",
        measurementId: "G-L0Y5TSVHFJ"
    }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! E:\xampp\htdocs\kingservice\qragency\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map